/**
 * WordPress dependencies
 */
import { createRoot } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import domReady from '@wordpress/dom-ready';

/**
 * External dependencies
 *
 */
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient({
	defaultOptions: { queries: { staleTime: 1000 * 60 * 5 } },
});

/**
 * Internal dependencies
 */
import CourseRows from './components/CourseRows';
import { useLocalVenueInstances } from '@hooks';

/**
 * Main Component
 */
function Main() {
	const { data, isPending, isError } = useLocalVenueInstances({
		postSlug: window.visitEduSettings.postSlug,
		apiUrl: window.visitEduSettings.apiBaseUrl,
	});

	return (
		<>
			<thead>
				<tr className="upcoming-instances__header">
					<th>Date</th>
					<th colSpan={2}>Name</th>
					<th>Status</th>
					<th>Enrolment</th>
				</tr>
			</thead>
			<tbody>
				<CourseRows
					data={data}
					isPending={isPending}
					isError={isError}
				/>
			</tbody>
		</>
	);
}

/**
 * Render block
 */
domReady(function () {
	createRoot(document.getElementById('upcoming-instances')).render(
		<QueryClientProvider client={queryClient}>
			<Main />
		</QueryClientProvider>
	);
});
